import {
  Module,
  VuexModule,
  Mutation,
  getModule,
} from "vuex-module-decorators";
import store from "@/store";
// Imported from the leaf module, NOT from "@/data/models/RoleSettings": that module imports this
// one, and the class-field initializer below runs during module evaluation, so importing it from
// there yields a half-initialized binding and "createDefaultRoleSettings is not a function".
import {
  createDefaultRoleSettings,
  RoleSettings,
} from "@/data/models/RoleSettingsDefaults";

const name = "roleSettings";

@Module({ dynamic: true, namespaced: true, store, name: name })
export class RoleSettingsVuexModule extends VuexModule {
  roleSettings: RoleSettings = createDefaultRoleSettings();

  /**
   * Whether the real role settings have arrived from Firestore yet.
   *
   * `roleSettings` starts out as the defaults, which grant nothing, and is replaced asynchronously by
   * the `observeRoleSettings` snapshot wired up in `Scaffold`. Without this flag the two states are
   * indistinguishable, so a capability check running in a component's `mounted()` on a cold page load
   * reads "denied" and cannot tell that it simply asked too early. Anything that *redirects* on a
   * capability must wait for this.
   */
  hasLoaded = false;

  @Mutation
  setRoleSettings(roleSettings: RoleSettings) {
    this.roleSettings = roleSettings;
    this.hasLoaded = true;
  }

  @Mutation
  clear() {
    this.roleSettings = createDefaultRoleSettings();
    this.hasLoaded = false;
  }
}

export const RoleSettingsModule = getModule(RoleSettingsVuexModule, store);
